import { defineMessages } from 'react-intl';

const messages = defineMessages({
  categoryTagsUpdated: {
    id: 'hooks.admin.organizations.categoryTagsUpdated',
    defaultMessage: 'Activity tags updated successfully!',
  },
  organizationClosed: {
    id: 'hooks.admin.organizations.organizationClosed',
    defaultMessage: 'Organization closed.',
  },
  organizationCreated: {
    id: 'hooks.admin.organizations.organizationCreated',
    defaultMessage: 'Organization created successfully!',
  },
  organizationDeleted: {
    id: 'hooks.admin.organizations.organizationDeleted',
    defaultMessage: 'Organization deleted successfully!',
  },
  organizationEdited: {
    id: 'hooks.admin.organizations.organizationEdited',
    defaultMessage: 'Organization edited successfully!',
  },
  // `useOrgDisplayName` — stands in for the organization name in "<Org> Home"
  // / "<Org> Schedule" titles when the selected organization has none.
  organizationFallbackName: {
    id: 'hooks.admin.organizations.organizationFallbackName',
    defaultMessage: 'Organization',
  },
  organizationLeft: {
    id: 'hooks.admin.organizations.organizationLeft',
    defaultMessage: 'You left the organization.',
  },
  rebrandThemeUpdated: {
    id: 'hooks.admin.organizations.rebrandThemeUpdated',
    defaultMessage: 'Branding updated successfully!',
  },
});

export default messages;
